import { useLocation } from 'react-router-dom';
import type { IpfLocation } from 'utils/history/IpfLocation';

export const useIpfLocation: () => IpfLocation = useLocation as any;
